import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import BrokerLayer from "../../components/Broker/BrokerLayer";

const BrokerPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Broker Management" />

        <BrokerLayer />
      </MasterLayout>
    </>
  );
};

export default BrokerPage;
